export default __webpack_public_path__ + "static/lia-Intraprise-interim-logo-0c53b6c4da185b887ae18119279cf93a.png";